exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comp-signup-wrapper {\n  padding: 50px;\n  max-width: 600px;\n  margin: 0 auto; }\n  .comp-signup-wrapper img {\n    display: block;\n    width: 250px;\n    margin: 0 auto; }\n  .comp-signup-wrapper .title {\n    text-align: center; }\n  .comp-signup-wrapper .intro {\n    font-size: 1.35em; }\n  .comp-signup-wrapper .success {\n    margin-top: 2em;\n    text-align: center; }\n  .comp-signup-wrapper .err-text {\n    display: flex;\n    align-items: flex-start;\n    margin: 1.5em 0; }\n    .comp-signup-wrapper .err-text p {\n      margin: 0 0 0 5px;\n      font-weight: 400; }\n", ""]);

// exports
